module.exports = __webpack_public_path__ + "img/join@0.75x.14fedbab.jpg";